import {useCallback, useState} from "react";
import {useSiren} from "../SirenContext";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {ContactGroup} from "../typedefs";
import useDebouncer from "../../../hooks/debouncer";
import {useQuery} from "react-query";
import {FilterQueryParams} from "../../../components/paginated-selector/filters/types";

export async function fetchContactGroups(page: number, limit: number, search: string, clientID: string | null, archived: boolean, departmentLinked?: boolean, departmentID?: string | null): Promise<PaginatedResponseV2<ContactGroup>> {
    const res = await platformAPI.get<PaginatedResponseV2<ContactGroup>>("api/contact-groups", {
        params: {page, limit, search, archived, ...(clientID ? {clientID} : {}), ...(departmentLinked !== undefined ? {departmentLinked} : {}), ...(departmentID ? {departmentID} : {})},
    });
    return res.data;
}

export function useGetContactGroups(archived: boolean) {
    const {clientID} = useSiren();

    return useCallback(async (search: string, page: number, filterParams?: FilterQueryParams): Promise<PaginatedResponseV2<ContactGroup> | null> => {
        const departmentLinked = filterParams?.departmentLinked as boolean | undefined;
        return fetchContactGroups(page, 10, search, clientID, archived, departmentLinked);
    }, [clientID, archived]);
}

export function useGetContactGroupOptions(clientID: string | null) {
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebouncer(search, 300);

    const {data, isLoading} = useQuery(
        ["contact-group-options", clientID, debouncedSearch],
        () => fetchContactGroups(1, 100, debouncedSearch, clientID, false),
        {enabled: !!clientID, cacheTime: 0},
    );

    return {data, search, setSearch, isLoading};
}
